import React from "react";
import PropTypes from "prop-types";
import moment from "moment";

const DebitCard = ({ userCard }) => {
  const {
    cardMask,
    cardholder,
    // card_status,
    bankType,
    expiration
  } = userCard;

  return (
    <div className="d-flex justify-content-center debit-card">
      <div className="card-front">
        <div className="shadow"/>
        <div className="image-container">
          {bankType || "Unknown Bank"}
        </div>
        <label>Card Number</label>
        {/* eslint-disable-next-line camelcase */}
        <input
          type="text"
          className="card-number"
          defaultValue={cardMask}
          readOnly={true}
        />
        <div className="cardholder-container">
          <label>Card Holder</label>
          {/* eslint-disable-next-line camelcase */}
          <input
            type="text"
            className="card-holder"
            defaultValue={cardholder}
            readOnly={true}
          />
        </div>
        <div className="exp-container">
          <label>Expiration</label>
          <input
            className="card-month"
            type="text"
            defaultValue={expiration ? moment(expiration)
              .format("MM") : ""}
            readOnly={true}
          />
          <input
            className="card-year"
            type="text"
            defaultValue={expiration ? moment(expiration)
              .format("YYYY") : ""}
            readOnly={true}
          />
        </div>
      </div>
    </div>
  );
};

DebitCard.propTypes = {
  userCard: PropTypes.object.isRequired
};

export default DebitCard;



// WEBPACK FOOTER //
// ./src/views/lib/components/debit-card.js